import styled from "styled-components";
import { Row, Col, Grid } from "antd";
import { RATypography } from "@/components/customs";
import { PATH_PUBLIC_IMAGES } from "@/config/images";
import { RAImage } from "@/components/customs";
import { SvgBookings, SvgStar, SvgSuitesAndFacilities } from "@/assets/icons";

const { useBreakpoint } = Grid;

const SERVICES_STEP = {
	FIRST: "FIRST",
	SECOND: "SECOND",
	THIRD: "THIRD",
};

export function ServiceJ1SIntroduction({ a_provision_in_luxury = {} }) {
	const screens = useBreakpoint();
	return (
		<div
			style={{
				width: "100vw",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				padding: "20px 0",
			}}
		>
			<Row justify="center" style={{ maxWidth: 1442, width: "100%" }}>
				<Col span={16}>
					<RATypography variant={screens?.md ? "h2" : "h4"} align="center">
						{a_provision_in_luxury?.title || ""}
					</RATypography>
				</Col>
			</Row>
			<Row justify="center" style={{ maxWidth: 1442, width: "100%" }}>
				<Col span={18}>
					<RATypography variant="p" align="center" top="20px" maxLines={4}>
						{a_provision_in_luxury?.sub_title || ""}
					</RATypography>
				</Col>
			</Row>
		</div>
	);
}

export function ServiceJ1SEachProvisionInLuxury({ a_provision_in_luxury = {}, step = SERVICES_STEP.FIRST }) {
	const screens = useBreakpoint();
	const renderTItle = () => {
		switch (step) {
			case SERVICES_STEP.FIRST:
				return a_provision_in_luxury?.hight_light1?.title;
			case SERVICES_STEP.SECOND:
				return a_provision_in_luxury?.hight_light2?.title;
			case SERVICES_STEP.THIRD:
				return a_provision_in_luxury?.hight_light3?.title;
			default:
				return "";
		}
	};

	const renderDescription = () => {
		switch (step) {
			case SERVICES_STEP.FIRST:
				return a_provision_in_luxury?.hight_light1?.description;
			case SERVICES_STEP.SECOND:
				return a_provision_in_luxury?.hight_light2?.description;
			case SERVICES_STEP.THIRD:
				return a_provision_in_luxury?.hight_light3?.description;
			default:
				return "";
		}
	};

	const renderPhoto = () => {
		switch (step) {
			case SERVICES_STEP.FIRST:
				return a_provision_in_luxury?.hight_light1?.photo;
			case SERVICES_STEP.SECOND:
				return a_provision_in_luxury?.hight_light2?.photo;
			case SERVICES_STEP.THIRD:
				return a_provision_in_luxury?.hight_light3?.photo;
			default:
				return PATH_PUBLIC_IMAGES.img_services_air_freight;
		}
	};

	const renderIconContent = () => {
		switch (step) {
			case SERVICES_STEP.FIRST:
				return <SvgSuitesAndFacilities />;
			case SERVICES_STEP.SECOND:
				return <SvgBookings />;
			case SERVICES_STEP.THIRD:
				return <SvgStar />;
			default:
				return "";
		}
	};

	return (
		<EachRowContainer>
			<EachRow
				justify="center"
				align="middle"
				style={{
					paddingTop: 20,
					paddingBottom: 20,
					animationDuration: "0.3s",
				}}
				gutter={[20, 0]}
			>
				<DescriptionCol
					md={{
						span: 12,
						order: 1,
					}}
					xs={{
						span: 24,
						order: 2,
					}}
				>
					<div style={{ width: "43px", height: "43px" }}>{renderIconContent()}</div>
					<RATypography variant="sub-heading2" top="10px">
						{renderTItle()}
					</RATypography>
					<RATypography variant="body3" top="10px" color="#595959">
						{renderDescription()}
					</RATypography>
				</DescriptionCol>
				<Col
					style={{ height: "100%" }}
					className="image-right"
					md={{
						span: 12,
						order: 2,
					}}
					xs={{
						span: 24,
						order: 1,
					}}
				>
					<RAImage
						url={renderPhoto()}
						width="100%"
						height={screens?.xl ? "360px" : screens?.lg ? "320px" : "210px"}
						borderRadius="16px"
					/>
				</Col>
			</EachRow>
		</EachRowContainer>
	);
}

const EachRowContainer = styled.div`
	width: 100%;
	max-width: 1442px;
	display: flex;
	/* padding-top: 160px; */
	flex-direction: column;
	justify-content: flex-end;
	align-items: flex-start;
	position: ${({ snap }) => (snap === "true" ? "absolute" : "static")};
	.center {
		width: 208px;
		height: 52px;
	}
	.btn {
		width: 208px;
		height: 52px;
		border-radius: 50px;
		cursor: pointer;
		background: transparent;
		border: 1px solid #ffb11a;
		outline: none;
		transition: 2s ease-in-out;
		box-sizing: border-box;
		position: relative;
	}
	.btn:hover {
		transition: 2s ease-in-out;
	}
	.btn:hover svg {
		stroke-dashoffset: -480;
	}
	.btn span {
		color: #222222;
		font-family: "DM Sans";
		font-weight: 500;
		font-size: 14px;
		letter-spacing: 3px;
		text-transform: uppercase;
		text-indent: 3px;
	}
`;
const EachRow = styled(Row)`
	margin: 50px 0;
	@media (max-width: 797px) {
		margin: 32px 0;
	}
	@media (max-width: 575px) {
		margin: 16px 0;
	}
`;
const DescriptionCol = styled(Col)`
	@media (max-width: 797px) {
		padding: 16px 20px 20px 20px;
	}
`;
